import React, { ChangeEvent, useState } from "react";
import FormLayout from "components/form/FormLayout";
import Sheet from "components/sheet/Sheet";
import Form from "components/form/Form";
import Input from "components/form/input/Input";
import TextEditor from "components/textEditor/textEditor";
import Portal from "elements/Portal";
import { useTranslation } from "react-i18next";
interface ICustomTextEdit {
  label?: string;
  description?: string;
  saveInput: (label: string, description?: string) => void;
  editModalOpen: boolean;
  closeEditModal: () => void;
  /** Viewable INPUT on the edit page itself. */
  children: React.ReactNode;
}

/** Structural display wrapper containing edit modal and its state. */
export default function CustomTextEdit(props: ICustomTextEdit) {
  const { label = "", description } = props;
  const { t } = useTranslation();
  const [state, setState] = useState({
    label: label,
    description: description,
  });

  return (
    <div className="input-view-wrap">
      {props.children}

      {/* EDITING  modal */}
      <Portal isMounted={props.editModalOpen}>
        <Sheet
          open={props.editModalOpen}
          title={t("Text")}
          onOk={() => props.saveInput(state.label, state.description)}
          okDisabled={state.label.length === 0}
          onCancel={() => {
            props.closeEditModal();
            setState(prev => ({ ...prev, open: false, label: label, description: description }));
          }}
          size="medium"
          okText={t("Save")}
        >
          <Form>
            <FormLayout>
              <FormLayout.Group>
                <Input
                  label={t("Label")}
                  defaultValue={label}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    setState(prev => ({ ...prev, label: e.target.value }))
                  }
                  className="input-edit-action"
                />
              </FormLayout.Group>
              <FormLayout.Group>
                <TextEditor
                  label={t("Content")}
                  markdownText={state.description}
                  markdownTextOnChange={(value: string) => setState(prev => ({ ...prev, description: value }))}
                />
              </FormLayout.Group>
            </FormLayout>
          </Form>
        </Sheet>
      </Portal>
    </div>
  );
}
